import { download } from '@invivodf/common/src/infrastructure/download.service'
import { ImportReportContent } from '@invivodf/common/src/contexts/parameters'
import { ProductSDK } from '@b2ag/module-product-sdk'
import ImportService from '@/services/import.service'
import { mapImportReportContent } from '@/services/import-reports/import-report.mapper'

/**
 * Segmentation des variants (QUOKKA-2455).
 *
 * L'import est volontairement découplé de l'import catalogue variant : il porte son
 * propre fichier CSV à deux colonnes (`assortment_product_uid`, `assortment_product_segments`)
 * et joue en full replace côté API — le fichier fait foi pour tout le distributeur.
 *
 * L'appel sans `subTaskId` est le cas manuel back-office : aucun callback importer n'est émis.
 */
export default class VariantSegmentationService {
  constructor(private readonly productSdk: ProductSDK) {}

  async import(distributorId: number, file: File): Promise<ImportReportContent> {
    const importReport = await this.productSdk.importVariantSegmentations(
      { cooperativeId: distributorId.toString() },
      { file },
    )

    // Le SDK type `line` en number, le domaine front en string : c'est exactement la
    // normalisation que fait `mapImportReportContent`, d'où le passage par `unknown`.
    return mapImportReportContent(importReport as unknown as ImportReportContent)
  }

  async download(distributorId: number, distributorName: string): Promise<void> {
    const csv = await this.productSdk.getVariantSegmentations({ cooperativeId: distributorId.toString() })

    download(new Blob([csv]), ImportService.createFileName(distributorName, 'variant-segmentations'))
  }
}
